import { Outlet } from "react-router-dom";

const Schemes = () => {
  return (
    <div className="w-full">
      <Outlet />
    </div>
  );
};

export default Schemes;
